import React from "react";

import { Avatar, Box, Flex } from "@chakra-ui/react";
import VerifiedUserTag from "../../global/components/product-marketing/VerifiedUserTag";
import LaunchdeckShortLogo from "../../global/components/helper-components/components/LaunchdeckShortLogo";
import MelogranoShortLogo from "../../global/styles/images/melograno-logo.png"

export default function LaunchdeckSignature({signatureType}) {
  switch(signatureType) {
    case("melograno"): {
      return (
        <Flex width='100%' justifyContent='flex-start' alignItems='center' minHeight='50px'>
        <Box display='flex' justifyContent='left' alignItems='center' width='100%'>
          <Box p='5px' m='5px'>
            <Flex alignItems='center'>
  
              <Avatar h='4em' w='4em' maxW='4em' name={'Melograno logo'} bg='gray.100' color='gray.700' src={MelogranoShortLogo} />
  
              <Flex flexDirection='column' ml='0.8em'>
                <Flex className="handwriting-font" fontSize='1.25em' align='center'>
                  House Melograno
                  <VerifiedUserTag isVerified={true} />
                </Flex>
              </Flex>
            </Flex>
          </Box>
        </Box>
      </Flex>
      )
    }
    case("example"): {

      return null
    }
    default: {
      return (
        <Flex width='100%' justifyContent='flex-start' alignItems='center' minHeight='50px'>
          <Box display='flex' justifyContent={'left'} alignItems='center' width='100%'>
            <Box p='5px' m='5px'>
              <Flex alignItems='center'>
    
                <LaunchdeckShortLogo boxSize='1.5em' />
    
                <Flex flexDirection='column' ml='0.8em'>
                  <Flex className="handwriting-font" fontSize='1.25em' align='center'>
                    Team  Launchdeck
                    <VerifiedUserTag isVerified={true} />
                  </Flex>
                </Flex>
              </Flex>
            </Box>
          </Box>
        </Flex>
      );
    }
  }
}